import api from "./axios";

type EmbedResponse = {
  slug: string;
  url: string;
};

export type MetabaseLink = {
  id: number | string;
  name?: string | null;
  url?: string | null;
};

export type MetabaseHotelDashboard = {
  hotel_id: number;
  company_id: number;
  collection_id: number | null;
  dashboard: MetabaseLink | null;
  tables: Record<string, MetabaseLink>;
};

export type MetabaseHotelEmbed = {
  hotel_id: number;
  type: string;
  card_id: number | string;
  name?: string | null;
  url: string;
};

export async function getOtaPlatformsEmbed(): Promise<EmbedResponse> {
  const { data } = await api.get<EmbedResponse>("/metabase/questions/sample");
  return data;
}

export async function getHotelDashboard(hotelId: number): Promise<MetabaseHotelDashboard> {
  const { data } = await api.get<MetabaseHotelDashboard>(`/metabase/hotels/${hotelId}/dashboard`);
  return data;
}

export async function getHotelEmbed(
  hotelId: number,
  type: "ota" | "categories" | "prices" | "dash" = "ota",
): Promise<MetabaseHotelEmbed> {
  const { data } = await api.get<MetabaseHotelEmbed>(`/metabase/hotels/${hotelId}/embed`, {
    params: { type },
  });
  return data;
}
